"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextSubmit = void 0;
const React = __importStar(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const icon_button_1 = require("./icon-button");
class TextSubmit extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = (event) => {
            this.setState({
                Value: event.target.value
            });
        };
        this.onSubmit = (event) => {
            event.preventDefault();
            if (!this.props.GetValidationError || !this.props.GetValidationError(this.state.Value)) {
                this.props.OnSubmit(this.state.Value);
            }
        };
        this.state = {
            Value: props.InitialValue || ""
        };
    }
    render() {
        const validationError = this.props.GetValidationError
            ? this.props.GetValidationError(this.state.Value)
            : null;
        return React.createElement("form", { onSubmit: this.onSubmit, onBlur: this.props.OnCancel },
            React.createElement("div", { className: "input-group input-group-sm" },
                React.createElement("input", { className: `form-control ${validationError ? "is-invalid" : ""}`, type: "text", value: this.state.Value, onChange: this.onChange, autoFocus: !!this.props.Autofocus, onFocus: this.props.Autofocus === "End" ? FocusAtEnd : undefined }),
                React.createElement(icon_button_1.IconButton, { icon: free_solid_svg_icons_1.faTimes, title: "Cancel", onClick: this.props.OnCancel }),
                React.createElement("div", { className: "invalid-feedback" }, validationError)));
    }
}
exports.TextSubmit = TextSubmit;
/** Moves the caret in an <input> element to the end of the current value */
function FocusAtEnd(event) {
    const val = event.target.value; //store the value of the element
    event.target.value = ""; //clear the value of the element
    event.target.value = val; //set that value back.
}
//# sourceMappingURL=text-submit.js.map